import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
// Pont jetons CSS → canvas : le graphique lit la charte au lieu de figer des
// couleurs. Le jour où la charte bascule, il suit sans être retouché.
import { jetons, alpha, optionsBase, fusionner } from '../../../../components/ndoe/chartTheme';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const DepenseMoisChart = ({data}) => {
    // Jetons lus DANS le rendu : au chargement du module le CSS n'est pas
    // garanti appliqué, getComputedStyle rendrait du vide et le pont
    // retomberait en silence sur ses valeurs de repli.
    const t = jetons();

    // Une dépense est une sortie d'argent à surveiller, pas une perte : `warn`
    // (orange) plutôt que `danger`, qui est réservé aux dettes et aux pertes
    // ailleurs dans l'app. Le remplissage translucide garde les barres lisibles
    // sur le papier crème tout en laissant le contour porter la couleur.
    const chartData = {
        labels: data?.map(item => item.mois),
        datasets: [
          {
            label: 'Dépenses Mensuelles',
            data: data?.map(item => item.total_mensuel),
            backgroundColor: alpha(t.warn, 0.22),
            borderColor: t.warn,
            borderWidth: 1,
          },
        ],
      };

    // optionsBase apporte la grille, les axes, l'info-bulle aux couleurs de la
    // charte et une animation sobre (420 ms, coupée si l'utilisateur a demandé
    // moins d'animations au niveau du système).
    // `interaction` repassé en 'nearest' : une seule série ici, le mode 'index'
    // n'apporte rien et fait réagir la barre au survol de tout l'axe.
    const options = fusionner(optionsBase(), {
      interaction: { mode: 'nearest', intersect: true },
    });

  return (
    // Hauteur explicite : optionsBase coupe maintainAspectRatio, et le canvas
    // s'effondrerait dans une Card antd qui n'impose aucune hauteur.
    <div style={{ height: 320 }}>
        <Bar data={chartData} options={options} />
    </div>
  )
}

export default DepenseMoisChart
